@import url("https://cdn.jsdelivr.net/npm/fomantic-ui@2.9.2/dist/semantic.min.css"); 
/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

.raw-html-style {
    /* padding: 10px; */
    font-size: 16px;
    padding-left: 24px;
 
}

.raw-html-style a:hover {
    text-decoration: underline !important;
}

.italic-style{
    font-style: italic;
    color: #444;
}

/* .raw-html-threelevel-style a {
    color: #b71d1d !important;
    font-size: 16px;
    text-decoration: none !important;
    position: relative; 
} */

.ui.styled.accordion {
    width: 100%;
    /* font-family: "Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-serif;
    font-size: 16px; */
}
.ui.styled.accordion .title {

    font-family:  Open Sans,sans-serif;
    font-size: 16px;
}

/* .ui.styled.accordion>.content {
    margin: 0;
  
    padding: 0px;
    padding-left: 20px;
} */

.info-popup {
    margin-left: 10px;
}

.ui.icon.button.info-popup 
{
    padding: 5px !important;
}


.ui.styled.accordion .active.title, .ui.styled.accordion[open] .title {
    background: 0 0;
    color: rgba(0,0,0,.95) !important;
    font-weight: bold !important;
}
.ui.styled.accordion .title:hover {
    background: 0 0;
    color: rgba(0,0,0,.95) !important;
    font-weight: bold !important;
}

.ui.styled.accordion .accordion>.title, .ui.styled.accordion>.title {
    margin: 0;
    padding: 0.75em 1em;
    border-top: 1px solid rgba(34,36,38,.15);
    color: #52585c;
    font-weight: normal;

}
.ui.accordion .active.title .chevron.icon, .ui.accordion .accordion .active.title .chevron.icon {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}


